export default __webpack_public_path__ + "static/media/b-5.8f10131c.svg";